import { useEffect, useState } from "react";
import { PrivateMainLayout } from "../../components/layout";
import { useOrganizationContext } from "../../contexts/OrganizationContext";
import { useFhirData } from "../../utils/useFhirData";
import { LargeContentBox, SecondaryButton } from "../../components/common";
import { EditCnesDialog } from "./components/EditCnesDialog";
import { Stack, Typography } from "@mui/material";
import { CardInfo } from "./components/CardInfo";
import { CardProfileClinic } from "./components/CardProfileClinic";
import { CardSubscription } from "./components/CardSubscription";
import { useViewContext } from "../../contexts/ViewContext";
import { useLocation, useNavigate } from "react-router-dom";
import { EditAliasDialog } from "./components/EditAliasDialog";
import { EditPhoneNumberDialog } from "./components/EditPhoneNumberDialog";
import { EditStateRegistrationDialog } from "./components/EditEnrollmentDialog";
import { PageHeader } from "@/components/common/PageHeader";
import { Business } from "@mui/icons-material";

export function ProfileClinic() {
  const location = useLocation();
  const { state } = useLocation();
  const { organization, typeOrganization } = useOrganizationContext();
  const [isEditCnesOpen, setIsEditCnesOpen] = useState<boolean>(false);
  const [isEditAliasOpen, setIsEditAliasOpen] = useState<boolean>(false);
  const [isEditPhoneNumberOpen, setIsEditPhoneNumberOpen] = useState<boolean>(
    state?.open === "editPhone" ? true : false
  );

  const [isEditEnrollmentOpen, setIsEditEnrollmentOpen] = useState<boolean>(
    state?.open === "editEnrollment" ? true : false
  );
  const { availableRoles } = useViewContext();
  const navigate = useNavigate();

  const cnes = useFhirData.findIdentifier(organization?.identifier, "cnes");
  const inscricaoEstadual = useFhirData.findIdentifier(
    organization?.identifier,
    "inscricaoEstadual"
  );
  const displayName =
    organization?.alias?.[0] !== "null"
      ? organization?.alias?.[0]
      : organization?.name;

  const clinicPhone = organization?.contact?.[0]?.telecom?.find((el) =>
    el.system?.includes("phone")
  )?.value;

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const elemento = document.getElementById(id);

      if (elemento) {
        elemento.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <LargeContentBox>
      <Stack spacing={3} width="100%" alignItems="center">
        <PageHeader
          title={`Perfil da Clínica ${organization?.alias?.[0]}`}
          description="Informações básicas e opções de gerenciamento da sua clínica"
          icon={Business}
          centered
        />

        {typeOrganization !== "bus" && <CardInfo />}

        <CardProfileClinic
          displayNameValue={displayName || ""}
          setIsEditCnesOpen={setIsEditCnesOpen}
          setIsEditAliasOpen={setIsEditAliasOpen}
          setIsEditAddressOpen={setIsEditPhoneNumberOpen}
          inscricaoEstadual={inscricaoEstadual}
          cnesValue={cnes}
          phoneNumber={clinicPhone}
          setIsEditEnrollmentOpen={setIsEditEnrollmentOpen}
        />
        {availableRoles?.includes("owner") && <CardSubscription />}
      </Stack>
      <Stack justifySelf="start" marginTop={3}>
        <SecondaryButton
          onClick={() => navigate(-1)}
          width="180px"
          height="50px"
        >
          Voltar
        </SecondaryButton>
      </Stack>

      {isEditCnesOpen && (
        <EditCnesDialog
          isOpen={isEditCnesOpen}
          setIsOpen={setIsEditCnesOpen}
          cnesValue={cnes}
          organization={organization}
        />
      )}

      {isEditAliasOpen && (
        <EditAliasDialog
          isOpen={isEditAliasOpen}
          setIsOpen={setIsEditAliasOpen}
          displayName={displayName || ""}
          organization={organization}
        />
      )}

      {isEditPhoneNumberOpen && (
        <EditPhoneNumberDialog
          isOpen={isEditPhoneNumberOpen}
          handleClose={() => setIsEditPhoneNumberOpen(false)}
          phoneNumber={clinicPhone}
        />
      )}

      {isEditEnrollmentOpen && (
        <EditStateRegistrationDialog
          isOpen={isEditEnrollmentOpen}
          setIsOpen={setIsEditEnrollmentOpen}
          displayStateRegistration={inscricaoEstadual}
          organization={organization}
        />
      )}
    </LargeContentBox>
  );
}
